// extracted by mini-css-extract-plugin
export default {"main":"MeditateSection_main__68AA6","inputContainer":"MeditateSection_inputContainer__Iu9eS","audio":"MeditateSection_audio__mx4u6"};